
const ApartYouIds = [
    // "511e8df9-672d-42b1-9711-d82beb7baf64",
    "b4889f16-8dc7-40f5-814b-5a1ed90d3947",
    "8b62cf50-d136-402b-abbc-81fb0b3ac162",
    "7f1d1e0b-acea-4c79-b442-f9dc557c4956",
    "2c31590f-739c-46b3-aca6-665e83a518ea",
    "bd8df831-ce3d-4596-ad10-3bbc188ded7d",
    "8fcf8b78-ed33-4575-b00a-4c8be2886ce0",
    "54aa721b-8f04-495b-923c-07d90e08fb92",
    "fea1efb3-9d97-4374-ab72-109bda0a9819",
    "4c126315-cf81-4e93-93fb-57ca1b07d220",
    "de6a6244-3a0c-44fb-b1e8-53f38d94019a",
    "e2ba6052-9f7f-4213-93a7-094317fc722f",
    "cf9b040e-bcf6-4d55-adbb-9fc705183e9c",
    "58e23f10-b106-483d-830e-5414ce661bed",
    "c9d798bc-2fb0-482e-8b3a-4577b94e788f",
    "72501582-74d3-4308-b139-2ba80beded69",
    "bf91530e-77a0-42a5-8d77-f487fb3245ad"
];

const isCostaGalana = hotelId => {
    return hotelId === "1de880e5-bfb6-4518-bd1b-095443bbc58b"
      //|| hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64"       // DEV Matias
        || hotelId === "8b91c3ba-6ef0-4667-805b-30b51f378ca5"
}
const isBelAir = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "c07d2d8a-9db1-412c-b24d-c0fcc3c5e7a0"
}
const isBrizoSalta = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "813161e1-a7a7-4916-953b-6dcf80b4c288"
}
const isGrandBrizoComahue = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "c0bb7b5c-cd44-4288-98f1-4868ea4e5c11"
}
const isGrandBrizoLaPlata = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "57c5ac85-75d3-4f30-9933-bbb12369ce40"
}
const isGrandBrizoBuenosAires = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "365edffa-c56e-4918-a16a-305452315e8d"
}
const isHotelIruna = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "a15be3ca-5bee-4167-89e2-aaacff0e827e"
}
const isHotelRivera = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "fb6185a6-5b1d-4f9a-8db8-60fff4014a6d"
}
const isBrizoNeuquen = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "f33a83b9-6284-46e6-8469-b5b17de2c9ba"
}
const isHotelCGBeach = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "44b7b2ff-e90c-4656-9dcf-96f797b6fdba"
}
const isLosCauquenes = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "a3c02b2b-fda7-4e13-be6c-72fa342e4a79"
}
const isSantaRosa = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "2645e6bf-25cc-4d87-8bc4-80b01f026fea"
}

const isAlvarezArguellez = hotelId => {
    return isCostaGalana(hotelId) || isBelAir(hotelId) || isBrizoSalta(hotelId) || isGrandBrizoComahue(hotelId) || isGrandBrizoLaPlata(hotelId) || isHotelIruna(hotelId) || isHotelRivera(hotelId) || isBrizoNeuquen(hotelId) || isHotelCGBeach(hotelId) || isGrandBrizoBuenosAires(hotelId) || isLosCauquenes(hotelId) || isSantaRosa(hotelId)
        || hotelId === "3be8d489-8fdd-42cb-b6f7-cc5f99c39b8b"; // DEV local
}

const isGrandBrizoFamily = hotelId => {
    return isBelAir(hotelId) || 
    isGrandBrizoComahue(hotelId) || 
    isGrandBrizoBuenosAires(hotelId)|| 
    isGrandBrizoLaPlata(hotelId)
}

const isBrizoFamily = hotelId => {
    return isBrizoSalta(hotelId) || 
    isBrizoNeuquen(hotelId);
}

const isOffgrid = hotelId => {
    return hotelId === "d55fa17e-d630-49ea-af48-4b2d2d9e557c"   // Klaudia
        || hotelId === "23a7aaa1-f022-477a-abc6-c6f0d0e92dbf"   // Lisa 
        || hotelId === "49e0c3db-e283-4c50-afc3-f16ab364733c"   // Punnu
        || hotelId === "9d20c705-e487-4fa1-bce9-78d67f551b9a"   // Max 
        || hotelId === "5f5da43a-39d9-4ef7-9298-976cad051f54"   // Johanna
        || hotelId === "7ef6b919-e25f-4153-9fb3-8e7939ff7252"   // Clive
        || hotelId === "8d03f1be-8796-4a8b-9263-ff9e7b9584eb"   // Quinton
        || hotelId === "6bb9ef92-5706-4fbf-a73b-913ee250b87e"   // Renate
        || hotelId === "bad68038-0134-4a46-8f97-e00ed4d2d6e4" // Gunter
        || hotelId === "04f8680c-1013-4915-8f20-b65166c3e5f6" // Carl
        || hotelId === "1452a98d-66a2-4214-bf48-371e70245417" // Marius
    //   || hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64"
}

const isOffgridMarius = hotelId => {
    return hotelId === "1452a98d-66a2-4214-bf48-371e70245417" //|| hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64"
}

const isBlackSummit = hotelId => {
    return hotelId === "b2501a57-ef47-445a-99fb-05324a4eb7e6";
}

// VICO-962 — solo black-summit (b2501a57): 150 CHF si roomCategoryId está acá; si no, 500
const BLACKSUMMIT_DEPOSIT_150_ROOM_CATEGORY_IDS = [
    "6deaf06b-4144-433d-9611-fa74f96ac1e0",  // STUDIO4 VORAB
    "69e4493a-76f1-48c4-9c4f-92a67d90045b",  // STUDIO5 FOPPA
    "35c761d8-6ec3-4b8f-a054-34a0150a9ff5",  // STUDIO2 NOVA
    "44b7005e-9c25-4d4c-a9c5-c9c00f7585d5",  // STUDIO1 MASEGN
    "83f29596-1558-43e0-96cd-5cfd8452cc60",  // APT1 RUSCHEIN
];

// VICO-962: asignada (Room) primero; si no, reservada (CheckIn.roomCategoryId)
const resolveBlackSummitDepositRoomCategoryId = (checkIn) => {
    const room = checkIn?.Room || {};
    const assigned = room.roomCategoryId || room.RoomCategory?.id;
    if (assigned) {
        return assigned;
    }
    return checkIn?.roomCategoryId;
};

const getBlackSummitDepositAmount = (hotelId, checkIn) => {
    if (!isBlackSummit(hotelId)) {
        return 500;
    }
    const roomCategoryId = resolveBlackSummitDepositRoomCategoryId(checkIn);
    if (roomCategoryId && BLACKSUMMIT_DEPOSIT_150_ROOM_CATEGORY_IDS.includes(roomCategoryId)) {
        return 150;
    }
    return 500;
}

const isHostz = hotelId => {
    let hostzIds = [
        // "511e8df9-672d-42b1-9711-d82beb7baf64", // dev-matias
        "d4676e50-71ed-4c01-bcdf-84b2b55b1890", // Black Summit (Hostz)
        "9983de2a-9f3e-4c75-9fb9-62e9855681e8", // Becozy
        "b58142a6-dfbc-4b7a-ab7e-8bac3e848b51", // San Carlo
        "efcf9764-9157-4454-9d24-76a053906322", // Beta House
        "59f21e07-f8a4-46f0-b294-b74f03348a9f", // The MYDE
        "ba6598fa-6808-417a-a391-250aeb89745e", // cozy
        "af8e44a0-c64c-4647-bb12-abd0af4b4a4b",  // Arosa
        "b09e49f0-d0ac-4723-ac65-8cce7aba74c8",  // swissstay
        "42b8cd5a-0aa8-407b-b9d8-c2f2b7e2b6cc",  // Steiners
        "b73a6165-65de-402b-9ac9-82ae4eca853f",  // Royal
    ];

    return hostzIds.includes(hotelId) || isBlackSummit(hotelId);
}
export const isSimplex = hotelId => {
    const simplexHotels = [
        // "511e8df9-672d-42b1-9711-d82beb7baf64", // dev-matias
        "0c761bb7-ce5a-4122-bdc1-b2bd02cc6443",
        "2370df3b-63d4-43d6-8152-b1520358ca57",
        "933df930-8a29-4895-93e3-0571bcedce72",
        "107ba05f-bceb-4551-86d2-904c74ca9848",
        "99865015-f97a-44f6-bb81-cc23e54cc031",
        "92c1c1c7-e471-4e82-8747-88d0342f9955",
        "a1d968d8-12de-48f5-bcbd-ba8d64640542",
        "d3837265-54fc-464e-8f0f-8cce31dddb51",
        "e133910b-dcff-4ee7-80e5-f1001125b0e4",
        "837b8419-28ec-4443-b588-e7299fd60935",
        "f5f1aa02-ac87-4908-8bf2-b6136182104a",
        "ea71bf37-8613-4d65-9b64-d7261d88e328",
        "682dcb26-310f-4169-a6f6-df6154dad46b",
        "db279a80-e54e-4b40-937b-2c9226c26d3b",
        "7e2c2665-1316-47e6-8f2c-98f7e858a01b",
        "d0ad7546-0cb0-4cf2-ac6c-23e84480aa3c",
        "b44a2499-b364-446a-8c7d-f0680b993b5d",
        "3962a13f-6212-4380-b8d2-36be7bdb8a1d"

    ]
    return simplexHotels.includes(hotelId)
}

const isHostzBlackSummit = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "d4676e50-71ed-4c01-bcdf-84b2b55b1890"
        || isBlackSummit(hotelId);
}
const isHostzBecozy = hotelId => {
    return /*hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "9983de2a-9f3e-4c75-9fb9-62e9855681e8";
}
const isHostzSanCarlo = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" || */ hotelId === "b58142a6-dfbc-4b7a-ab7e-8bac3e848b51";
}
const isHostzBetaHouse = hotelId => {
    return  /*hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" || */  hotelId === "efcf9764-9157-4454-9d24-76a053906322";
}
const isHostzSigma = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/   hotelId === "efcf9764-9157-4454-9d24-76a053906322";
}
const isHostzMyde = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" || */ hotelId === "59f21e07-f8a4-46f0-b294-b74f03348a9f";
}
const isHostzArosa = hotelId => {
    return  /*hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" || */ hotelId === "af8e44a0-c64c-4647-bb12-abd0af4b4a4b";
}
const isHostzCozy = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "ba6598fa-6808-417a-a391-250aeb89745e";
}
const isHostzSwissstay = hotelId => {
    return   /*hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" || */ hotelId === "b09e49f0-d0ac-4723-ac65-8cce7aba74c8";
}
const isHostzSteiners = hotelId => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "42b8cd5a-0aa8-407b-b9d8-c2f2b7e2b6cc";  // Steiners;
}

const isKalmStay = hotelId => {
    return   hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" || hotelId === "44dc5e46-b6ca-43c9-8ec7-e4a4b5ebb66b"
        || hotelId === "eb618aea-3d7b-4496-986a-b7f034554ac8";  // Kalm Stay Smart Studios
}

const isGemunder = hotelId => {
    return /*hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "9324d1b3-c49b-45fd-8a4e-d48bb5c48516";
}

const isApartYou = (hotelId) => {
    return ApartYouIds.includes(hotelId)
};

const isDemo = (hotelId) => {
    return hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64"
}
const isRoyal = (hotelId) => {
    return /* hotelId === "511e8df9-672d-42b1-9711-d82beb7baf64" ||*/ hotelId === "b73a6165-65de-402b-9ac9-82ae4eca853f"
}

/** Leyenda "Precio sin impuestos Nacionales". Los Cauquenes no aplica impuestos. */
const hotelShowsPriceWithoutTaxes = (hotelId) => {
    return (isAlvarezArguellez(hotelId) && !isLosCauquenes(hotelId)) || isRoyal(hotelId) || isDemo(hotelId);
}

const apartmentsRooms = (hotelId) => {
    if (isSimplex(hotelId) || isHostzBlackSummit(hotelId) || isHostzSwissstay(hotelId) || isHostzMyde(hotelId)) {
        return true;
    }
    return false;
}


const NEWSLETTER_HOTEL_IDS = [
    "b09e49f0-d0ac-4723-ac65-8cce7aba74c8",  // swissstay
    "efcf9764-9157-4454-9d24-76a053906322",  // sigma
    "511e8df9-672d-42b1-9711-d82beb7baf64",  // dev-matias
];
export const isNewsletterHotel = (hotelId) => NEWSLETTER_HOTEL_IDS.includes(hotelId);

export {
    isDemo,
    isRoyal,
    hotelShowsPriceWithoutTaxes,
    isApartYou,
    isCostaGalana,
    isHotelCGBeach,
    isLosCauquenes,
    isSantaRosa,
    isBelAir,
    isBrizoSalta,
    isGrandBrizoComahue,
    isGrandBrizoLaPlata,
    isGrandBrizoBuenosAires,
    isHotelIruna,
    isHotelRivera,
    isAlvarezArguellez,
    isOffgrid,
    isOffgridMarius,
    isHostz,
    isBlackSummit,
    resolveBlackSummitDepositRoomCategoryId,
    getBlackSummitDepositAmount,
    isHostzBlackSummit,
    isHostzBecozy,
    isHostzSanCarlo,
    isHostzBetaHouse,
    isHostzSigma,
    isHostzMyde,
    isHostzArosa,
    isHostzCozy,
    isHostzSwissstay,
    isHostzSteiners,
    isKalmStay,
    isGemunder,
    apartmentsRooms,
    isGrandBrizoFamily,
    isBrizoFamily,
}